<template>
  <v-card elevation="0" flat>
    <div class="scrollable-container">
      <v-card-text>
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <h3 class="subtitle-1">{{ t('availablePaymentMethod.optionOne.title') }}</h3>
              <ul>
                <li>{{ t('availablePaymentMethod.optionOne.descriptionOne') }}</li>
                <li>{{ t('availablePaymentMethod.optionOne.descriptionTwo') }}</li>
              </ul>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <h3 class="subtitle-1">{{ t('availablePaymentMethod.optionTwo.title') }}</h3>
              <ul>
                <li>{{ t('availablePaymentMethod.optionTwo.descriptionOne') }}</li>
                <li>{{ t('availablePaymentMethod.optionTwo.descriptionTwo') }}</li>
                <li>{{ t('availablePaymentMethod.optionTwo.descriptionThree') }}</li>
              </ul>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <h3 class="subtitle-1">{{ t('availablePaymentMethod.optionThree.title') }}</h3>
              <ul>
                <li>{{ t('availablePaymentMethod.optionThree.descriptionOne') }}</li>
                <li>{{ t('availablePaymentMethod.optionThree.descriptionTwo') }}</li>
              </ul>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <h3 class="subtitle-1">{{ t('availablePaymentMethod.optionFour.title') }}</h3>
              <ul>
                <li>{{ t('availablePaymentMethod.optionFour.descriptionOne') }}</li>
                <li>{{ t('availablePaymentMethod.optionFour.descriptionTwo') }}</li>
              </ul>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <h3 class="subtitle-1">{{ t('availablePaymentMethod.optionFive.title') }}</h3>
              <ul>
                <li>{{ t('availablePaymentMethod.optionFive.descriptionOne') }}</li>
                <li>{{ t('availablePaymentMethod.optionFive.descriptionTwo') }}</li>
              </ul>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <h3 class="subtitle-1">{{ t('availablePaymentMethod.optionSix.title') }}</h3>
              <ul>
                <li>{{ t('availablePaymentMethod.optionSix.descriptionOne') }}</li>
                <li>{{ t('availablePaymentMethod.optionSix.descriptionTwo') }}</li>
                <li>{{ t('availablePaymentMethod.optionSix.descriptionThree') }}</li>
              </ul>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <h3 class="subtitle-1">{{ t('availablePaymentMethod.optionSeven.title') }}</h3>
              <ul>
                <li>{{ t('availablePaymentMethod.optionSeven.descriptionOne') }}</li>
              </ul>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </div>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useLabel } from '@/composables/useLabel';

export default defineComponent({
  name: 'PaymentTermsDialog',
  setup() {
    const { t } = useLabel();

    return { t };
  }
});
</script>

<style scoped>
.scrollable-container {
  max-height: 90vh;
  overflow-y: auto;
  padding-right: 8px;
}

ul {
  padding-left: 1.25rem;
  margin: 0.25rem 0 1rem 0;
}

li {
  margin-bottom: 0.5rem;
  line-height: 1.4;
}
</style>